import { Fragment } from 'react'
import PropTypes from 'prop-types'

// Help copy is text, drawn as text; a line break in it is the one piece of layout it carries.
const HelpText = ({ text }) => (
  <p>
    {text.split('\n').map((line, index) => (
      <Fragment key={index}>
        {0 < index ? <br /> : null}
        {line}
      </Fragment>
    ))}
  </p>
)

HelpText.propTypes = {
  text: PropTypes.string.isRequired
}

export default HelpText
